import { ReactComponent as Info } from "commons/assets/icons/info.svg";

type PropsType = {
    tooltip: string | JSX.Element;
    icon?: JSX.Element;
};

function Tooltip({ tooltip, icon }: PropsType) {
    return (
        <div className={"helper-tooltip"}>
            {icon ? (
                icon
            ) : (
                <button type={"button"} className={"helper-svg"}>
                    <Info />
                </button>
            )}

            <div className={"helper-arrow"} />

            <div className={"helper-tooltip"}>
                {typeof tooltip === "string" ? <p>{tooltip}</p> : tooltip}
            </div>
        </div>
    );
}

export default Tooltip;
